import React from "react";
import { Provider } from "react-redux";
import Routes from "./routes/Routes";

import ReduxToastr from "react-redux-toastr";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import store from "./redux/store";
import { GoogleOAuthProvider } from "@react-oauth/google";
import axios from "axios";
import { useEffect } from "react";

import { ReactChannelIO } from "react-channel-plugin";

const App = () => {
  // const callApi = async () => {
  //   const check = await axios.get("/apitest");
  //   console.log("API call:", check.data.name);
  // };

  // useEffect(() => {
  //   callApi();
  // }, []);

  return (
    <Provider store={store}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <ReactChannelIO
          pluginKey={process.env.REACT_APP_CHANNEL_ID_PLUGIN_KEY}
          language="en"
          autoBoot
        >
          <Routes />
          <ReduxToastr
            timeOut={5000}
            newestOnTop={true}
            position="top-center"
            transitionIn="fadeIn"
            transitionOut="fadeOut"
            progressBar
            closeOnToastrClick
          />
        </ReactChannelIO>
      </GoogleOAuthProvider>
    </Provider>
  );
};
export default App;
